// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  /* font-family: Source Sans Pro !important; */
}

/* Hide vertical scrollbar but still scrollable */
::-webkit-scrollbar {
  width: 0px !important;
  background: transparent !important;
}

h5 {
  margin-top: 10px;
  color: red;
}

.table-file-upload {
  border-bottom: 1px solid #babfc1 !important;
  margin-bottom: 10px;
  max-width: 180px;
  padding-left: 10px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
input[type=text]{
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.button:hover {
  opacity: 0.8;
}
.container {
  padding: 16px;
}
.space {
  padding-top: 10px;
  padding-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/css/global.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;AAC/C;;AAEA,iDAAiD;AACjD;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["* {\n  /* font-family: Source Sans Pro !important; */\n}\n\n/* Hide vertical scrollbar but still scrollable */\n::-webkit-scrollbar {\n  width: 0px !important;\n  background: transparent !important;\n}\n\nh5 {\n  margin-top: 10px;\n  color: red;\n}\n\n.table-file-upload {\n  border-bottom: 1px solid #babfc1 !important;\n  margin-bottom: 10px;\n  max-width: 180px;\n  padding-left: 10px;\n  cursor: pointer;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\ninput[type=text]{\n  width: 100%;\n  padding: 12px 20px;\n  margin: 8px 0;\n  display: inline-block;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n}\n.button:hover {\n  opacity: 0.8;\n}\n.container {\n  padding: 16px;\n}\n.space {\n  padding-top: 10px;\n  padding-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
